export default __webpack_public_path__ + "static/media/img2.d380d99f.png";